module.exports = __webpack_public_path__ + "static/Bancor-c26bdefc8abfdf3d770bf16ff2b533d3.png";